<template>
   <div
        v-if="show"
        class="notification"
        :class="[notification.level]"
    >
        <div>
            {{ notification.body }}
        </div>
        <button
            @click.prevent="reset"
            class="rouned-full p-2 flex items-center justify-center"
        >
            <icon type="x" class="w-4 h-4" />
        </button>
    </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useNotificationStore } from '@/stores/notification'

const notification = useNotificationStore()

const reset = () => notification.clear()

const show = computed(() => {
    return notification.type == 'alert'
})

onMounted(() => {
    window.addEventListener('keyup', (e) => {
        if(['Esc', 'Escape'].includes(e.key)) {
            reset();
        }
    })
})
</script>
